// removed by extract-text-webpack-plugin
module.exports = {"container":"_3Y6t2","backdrop":"_1Zuei","modal":"_3_TqG","withShadow":"_1-QmZ","closeIcon":"_2ui-m","focusWrapper":"_2gs9r"};


//////////////////
// WEBPACK FOOTER
// ./app/components/modal/modal.scss
// module id = 624
// module chunks = 3 4 5 6 7